import React from "react";
import { Radio, Table, Input, Button, Grid, Spin, Pagination } from "antd";
import Title from "antd/es/typography/Title";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { SearchOutlined } from "@ant-design/icons";
import upload from "../../Assets/Icons/arrow-up-from-bracket.svg";
import download from "../../Assets/Icons/download.svg";
import add from "../../Assets/Icons/plus-large.svg";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  downloadJobs,
  resetJobDetails,
  uploadJobs,
} from "../../Redux/Slices/JobSlice";

const getRowKey = (record, index) =>
  record?.id ?? record?.key ?? record?.user?.id ?? index;

const getCellValue = (column, record, index) => {
  const data = column.dataIndex ? record[column.dataIndex] : record;
  if (column.render) {
    return column.render(data, record, index);
  }
  if (column.dataIndex) {
    return record[column.dataIndex];
  }
  return null;
};

const MobileTableCards = ({ dataSource, columns, loading }) => {
  if (loading) {
    return (
      <div className="mobile-table-cards mobile-table-cards-loading">
        <Spin />
      </div>
    );
  }

  const labeledColumns = columns.filter((col) => col.title);

  return (
    <div className="mobile-table-cards">
      {dataSource?.map((record, index) => (
        <div
          key={getRowKey(record, index)}
          className="mobile-table-card"
        >
          {labeledColumns.map((col) => {
            const isAction =
              col.key === "action" || col.title === "Action";
            return (
              <div
                key={col.key || col.dataIndex || col.title}
                className={`mobile-table-card-row${
                  isAction ? " mobile-table-card-row-action" : ""
                }`}
              >
                <span className="mobile-table-card-label">{col.title}</span>
                <span className="mobile-table-card-value">
                  {getCellValue(col, record, index)}
                </span>
              </div>
            );
          })}
        </div>
      ))}
    </div>
  );
};

const CustomTable = ({
  title,
  dataSource,
  columns,
  loading,
  renderTabs,
  status,
  handleStatus,
  pagination,
  onChange,
  onSearch,
  isJob,
  renderTabsJobs,
  headerExtra,
  body,
}) => {
  const { downloading, uploadLoading } = useSelector((state) => state.JobSlice);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { useBreakpoint } = Grid;
  const { md } = useBreakpoint();
  const isMobile = md === false;

  const handleAddJob = () => {
    dispatch(resetJobDetails());
    navigate("/dashboard/jobs/add-job");
  };
  const handleDownload = () => dispatch(downloadJobs());
  const handleUpload = (e) => {
    console.log("inside puload");
    const file = e.target.files[0];
    if (!file.name.includes("xlsx")) {
      toast.error("Please upload excel file only ");
    } else dispatch(uploadJobs({ file, navigate, toast }));
    console.log("file", file);
  };

  const tablePagination =
    pagination &&
    (isMobile
      ? {
          ...pagination,
          simple: true,
          showSizeChanger: false,
        }
      : pagination);

  const actionBtnSize = isMobile ? "middle" : "large";

  return (
    <>
      <div className="table-header  ">
        <div className="table-title-container">
          <Title
            level={3}
            className="text-black internal-table-title font-medium "
          >
            {title}
          </Title>
          {(renderTabsJobs || headerExtra) && (
            <div className="table-title-controls">
              {renderTabsJobs && (
                <Radio.Group
                  onChange={handleStatus}
                  value={status}
                  className="job-radio-group"
                >
                  <Radio.Button value="approved">Approved</Radio.Button>
                  <Radio.Button value="pending">Under Review</Radio.Button>
                  <Radio.Button value="rejected">Rejected</Radio.Button>
                  <Radio.Button value="archived">Archived</Radio.Button>
                </Radio.Group>
              )}
              {headerExtra}
            </div>
          )}
        </div>

        <div className="table-header-right">
          {onSearch && (
            <div className="table-header-search">
              <Input
                placeholder="Search here..."
                onChange={onSearch}
                prefix={<SearchOutlined />}
                style={{ height: isMobile ? "36px" : "40px" }}
                className="search-input"
              />
            </div>
          )}

          {renderTabs && (
            <Radio.Group onChange={handleStatus} value={status}>
              <Radio.Button value="approved">Approved</Radio.Button>
              <Radio.Button value="review">Under Review</Radio.Button>
            </Radio.Group>
          )}
          {isJob && (
            <div className="table-header-extra-actions">
              <Button
                icon={<img src={upload} alt="upload" />}
                size={actionBtnSize}
                className="d-flex align-center btn-14 job-table-action import-jobs-btn"
                disabled={uploadLoading}
              >
                <input
                  type="file"
                  className="upload-thumbnail-input"
                  onChange={handleUpload}
                />
                Import jobs
              </Button>
              <Button
                icon={<img src={download} alt="upload" />}
                size={actionBtnSize}
                className="d-flex align-center btn-14 job-table-action"
                disabled={downloading}
                onClick={handleDownload}
              >
                Download jobs
              </Button>

              <Button
                icon={<img src={add} alt="upload" />}
                size={actionBtnSize}
                type="primary"
                className="d-flex align-center btn-14 job-table-action"
                onClick={handleAddJob}
              >
                Create new job
              </Button>
            </div>
          )}
        </div>
      </div>
      <div className="table-wrapper">
        <ToastContainer />
        {body ||
          (isMobile ? (
            <>
              <MobileTableCards
                dataSource={dataSource}
                columns={columns}
                loading={loading}
              />
              {tablePagination && (
                <Pagination
                  className="mobile-table-pagination"
                  total={tablePagination.total}
                  current={Number(tablePagination.current)}
                  pageSize={tablePagination.pageSize}
                  onChange={tablePagination.onChange}
                  simple
                  showSizeChanger={false}
                  showTotal={tablePagination.showTotal}
                />
              )}
            </>
          ) : (
            <Table
              dataSource={dataSource}
              columns={columns}
              loading={loading}
              pagination={tablePagination}
              onChange={onChange}
              rowKey={getRowKey}
            />
          ))}
      </div>
    </>
  );
};

export default CustomTable;
